{
	"printDate": "Emitido dia",
	"reportPeriod": "Período do relatório",
	"emissionInfo": "Emitido por",
	"eventDate": "Data do evento"
}
